import { useQuery } from '@tanstack/react-query';
import DOMPurify from 'dompurify';
import { DEFAULT_PRIVACY_HTML, type PublicLegalResponse } from '@bm/contracts';
import { api } from '../lib/api';
import { LegalPageLayout } from '../components/LegalPageLayout';

/** Datenschutzerklärung — Inhalt kommt vollständig aus
 * `platformSettings.legal.privacyHtml`, siehe `ImprintPage.tsx` für die
 * ausführliche Erklärung dieses Musters (öffentlicher Endpunkt,
 * DOMPurify-Sanitisierung, editierbar unter Plattform › Impressum &
 * Datenschutz). */
export function PrivacyPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['public', 'legal'],
    queryFn: () => api<PublicLegalResponse>('/public/legal'),
  });

  const html = DOMPurify.sanitize(data?.privacyHtml ?? DEFAULT_PRIVACY_HTML);

  return (
    <LegalPageLayout title="Datenschutzerklärung">
      {isLoading ? (
        <p className="text-sm text-slate-400">Lädt…</p>
      ) : (
        <div className="legal-content" dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </LegalPageLayout>
  );
}
